import { defineMessages } from 'react-intl';

export const giftCardCheckoutMessages = defineMessages({
  errorBannerText: {
    defaultMessage: 'Unable to purchase gift card. Please try again later.',
    description:
      'Gift Card Checkout | Submission | Failed submission banner text',
  },
});
